import styled from "@emotion/styled/macro"
import { fontSize, size } from "@styles/theme"
import { PiSpinnerBold } from "react-icons/pi"

const Container = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  height: 100dvh;
  width: 100dvw;
  padding-bottom: ${size(15)};
  z-index: 2147483647;

  background-color: rgba(0,0,0,0.5);
  backdrop-filter: blur(2.5px);
  
  letter-spacing: 0.5px;
  font-size: ${fontSize('lg')};
  font-weight: bold;
`

const ImagePreparationLoading = () => {
  return (
    <Container>
      <PiSpinnerBold
        size={size(3)}
        className='animation_rotation'
      />
      &nbsp;
      Preparing Image
    </Container>
  )
}

export default ImagePreparationLoading
